import Radio from './Radio';
import forwardRef from '../utils/forwardRef';
export default forwardRef({
  name: 'Radio',
  ClassComponent: Radio
});